import React from "react";
import Icon1 from '../../assest/icon1.png'
import Icon2 from '../../assest/icon2.png'
import Icon3 from '../../assest/icon3.png'
import Icon4 from '../../assest/icon4.png'
import Icon5 from '../../assest/icon5.png'
import Icon6 from '../../assest/icon6.png'
import Icon7 from '../../assest/icon7.png'
import Icon8 from '../../assest/icon8.png'
import Icon9 from '../../assest/icon9.png'
import "./benefits.scss";

const benefitsData = [
	{
		icon: Icon1,
		title: "Renewals",
		desc: "Track renewal dates, avoid revenue leakage, and ensure timely follow-ups."
	},
	{
		icon: Icon2,
		title: "Self-Service Portals",
		desc: "User-friendly platforms for employees, customers, and vendors"
	},
	{
		icon: Icon3,
		title: "Real-Time Insights",
		desc: "User-friendly platforms for employees, customers, and vendors"
	},
	{
		icon: Icon4,
		title: "QBRs",
		desc: "Run Quarterly Business Reviews aligned with customer goals and KPIs."
	},
	{
		icon: Icon5,
		title: "Ticketing Management",
		desc: "Manage support tickets with defined SLAs and faster resolution"
	},
	{
		icon: Icon6,
		title: "NPS",
		desc: "Customer satisfaction, helping business improve experiences"
	},
	{
		icon: Icon7,
		title: "Market Analysis",
		desc: "Gathering data on competitors, customers, and more."
	},
	{
		icon: Icon8,
		title: "Customer Success",
		desc: "Ensure satisfaction, retention, and proactive support."
	},
	{
		icon: Icon9,
		title: "AI Suite",
		desc: "Enhances account lifecycle with insights for smarter decisions."
	}
];

const Benefits = () => {
	return (
		<section id="benefits" className="benefits-section">
			<h2 className="title">Benefits</h2>
			
			<div className="benefits-container">
				{benefitsData.map((item, index) => (
					<div className="benefit-card" key={index}>
						<div className="icon"><img src={item.icon} alt=""/></div>
						<h4>{item.title}</h4>
						<p>{item.desc}</p>
					</div>
				))}
			</div>
		</section>
	);
};

export default Benefits;